import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { useCreditConfig } from '../../../contexts/CreditConfigContext';

const GenerateButtonWithCredits = ({ isGenerating, generationProgress, onClick, disabled, toolId, generationSettings, className }) => {
  const { t } = useI18n();
  const { getToolCost, getImageGenerationCredits } = useCreditConfig();
  const hasResolutionOrModel =
    generationSettings &&
    typeof generationSettings === 'object' &&
    (typeof generationSettings.resolution === 'string' || typeof generationSettings.model === 'string');
  const cost = hasResolutionOrModel
    ? getImageGenerationCredits({
        toolId,
        model: generationSettings?.model,
        resolution: generationSettings?.resolution
      })
    : getToolCost(toolId);

  return (
    <button 
      className={`${className || 'generate-button'} ${isGenerating ? 'generating' : ''}`}
      onClick={onClick}
      disabled={disabled}
      style={{
        background: isGenerating 
          ? `linear-gradient(to right, #00b894 ${generationProgress}%, #666 ${generationProgress}%)`
          : '#00b894'
      }}
    >
      {isGenerating 
        ? `${t('aiToolTemplate.generating')} ${Math.round(generationProgress)}% (${cost} ${t('credits.credits')})`
        : `${t('aiToolTemplate.startGeneration')} (${cost} ${t('credits.credits')})`}
    </button>
  );
};

export default GenerateButtonWithCredits;
